document.addEventListener("DOMContentLoaded", () => {
    initWeedingFaqAccordion();
  });
  
  document.addEventListener("turbo:load", () => {
    initWeedingFaqAccordion();
  });
  
  function initWeedingFaqAccordion() {
    const faqQuestions = document.querySelectorAll(".weeding-faq-question");
    if (!faqQuestions.length) return;
  
    faqQuestions.forEach((button) => {
      button.addEventListener("click", () => {
        const answer = button.nextElementSibling;
        const isOpen = answer.style.display === "block";
  
        document.querySelectorAll(".weeding-faq-answer").forEach((ans) => {
          ans.style.display = "none";
        });
  
        if (!isOpen) {
          answer.style.display = "block";
        }
      });
    });
  }